import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  container: {
    maxHeight: 300,
    overflow: 'auto',
  },
  head: {
    // display: 'block',
    // width: '100%',
  },
  body: {
    // display: 'block',
    // width: '100%',
    // maxHeight: 200,
    // overflow: 'auto',
  },
  table: {
    // minWidth: 650,
  },
});

const createData = (name, date) => {
  return { name, date };
};

const RegionTable = ({ communities }) => {
  const classes = useStyles();
  if (!communities) return null;

  communities.sort((community, otherCommunity) => community.name.localeCompare(otherCommunity.name));

  let rows = communities.map((community) => createData(community.name, community.joiningDate));

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.head}>
          <TableRow>
            <TableCell align="center">Назва ТГ</TableCell>
            <TableCell align="center">Дата приєднання</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.body}>
          {rows.map((row) => (
            <TableRow key={new Date() + Math.random()}>
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="center">{row.date}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RegionTable;
